import { render, staticRenderFns } from "./preferenceTable.vue?vue&type=template&id=a9a200e2&scoped=true&"
import script from "./preferenceTable.vue?vue&type=script&lang=js&"
export * from "./preferenceTable.vue?vue&type=script&lang=js&"
import style0 from "./preferenceTable.vue?vue&type=style&index=0&id=a9a200e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a200e2",
  null
  
)

export default component.exports